module.exports = __webpack_public_path__ + "img/building.433bdc46.svg";